import { useLanguage } from "@/context/LanguageContext";

const BrazilFlag = () => (
  <svg viewBox="0 0 16 11" className="h-[11px] w-4 rounded-[2px]" aria-hidden="true">
    <rect width="16" height="11" fill="#009C3B" />
    <polygon points="8,1.2 14.8,5.5 8,9.8 1.2,5.5" fill="#FFDF00" />
    <circle cx="8" cy="5.5" r="2.2" fill="#002776" />
  </svg>
);

const UsaFlag = () => (
  <svg viewBox="0 0 16 11" className="h-[11px] w-4 rounded-[2px]" aria-hidden="true">
    <rect width="16" height="11" fill="#B22234" />
    {[1, 3, 5, 7, 9, 11].map((i) => (
      <rect key={i} y={i * 0.846} width="16" height="0.846" fill="#FFFFFF" />
    ))}
    <rect width="7" height="5.92" fill="#3C3B6E" />
  </svg>
);

export default function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();
  return (
    <div className="flex flex-col items-center gap-1.5" data-testid="language-switcher" role="group" aria-label="Language">
      <div className="flex items-center rounded-full border border-white/15 bg-white/5 p-0.5">
        {["pt", "en"].map((value) => (
          <button
            key={value}
            onClick={() => setLang(value)}
            data-testid={`lang-switch-${value}`}
            className={`rounded-full px-3 py-1 font-mono text-[10px] font-medium uppercase tracking-[0.15em] transition-colors duration-300 ${
              lang === value ? "bg-blue-500 text-white" : "text-slate-400 hover:text-slate-200"
            }`}
          >
            {value}
          </button>
        ))}
      </div>
      <div className="flex items-center justify-center">
        <button
          onClick={() => setLang(lang === "pt" ? "en" : "pt")}
          data-testid="lang-flag"
          aria-label={lang === "pt" ? "Mudar para English" : "Switch to Português"}
          className="rounded-sm opacity-80 transition-all duration-300 hover:opacity-100 hover:ring-1 hover:ring-blue-400/60"
        >
          {lang === "pt" ? <BrazilFlag /> : <UsaFlag />}
        </button>
      </div>
    </div>
  );
}
